import makeStyles from '@mui/styles/makeStyles';
import { COLORS } from 'constants/styles';

export const useInputStyles = makeStyles(
  {
    root: {
      position: 'relative',
      borderRadius: 4,
      backgroundColor: '#F7F7F9',
      height: 60,
    },
    label: {
      top: 10,
      left: 10,
      position: 'absolute',
      color: '#0F2F4C',
      fontSize: 14,
      fontWeight: 500,
    },
    input: {
      border: 0,
      width: '100%',
      paddingTop: 30,
      padding: 10,
      color: COLORS.text,
      fontSize: 18,
      fontWeight: 500,
    },
  },
  { name: 'ContactsForm' },
);

export const useSelectStyles = makeStyles(
  {
    root: {
      position: 'relative',
      borderRadius: 4,
      backgroundColor: '#F7F7F9',
    },
    label: {
      top: 10,
      left: 10,
      position: 'absolute',
      color: '#0F2F4C',
      fontSize: 14,
      fontWeight: 500,
    },
    select: {
      height: 60,
      border: 0,
      width: '100%',
      paddingTop: 30,
      padding: 10,
      color: COLORS.text,
      fontSize: 18,
      fontWeight: 500,
      appearance: 'none',
      backgroundColor: COLORS.clear,
      margin: 0,
    },
  },
  { name: 'ContactsForm' },
);

export default makeStyles(
  {
    root: {
      display: 'flex',
      flexDirection: 'column',

      '& > * + *': {
        marginTop: 40,
      },
    },
    form: {
      position: 'relative',
    },
    inputs: {
      '& > * + *': {
        marginTop: 10,
      },
    },
    loader: {
      display: 'flex',
      alignItems: 'center',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
    },
  },
  { name: 'ContactsForm' },
);
